$('.selector-slick').each(function () {
    let $slider = $(this);
    let slidesToShow = $slider.data('slides-show') ?? 3;
    let withArrows = $slider.data('slide-arrows') ?? false;
    let withDots = $slider.data('slide-dots') ?? true;
    let dotsClass = $slider.data('slide-dots-class') ?? 'slick-dots';
    let variableWidth = $slider.data('slide-variable-width') ?? false;

    $slider.on('init', function (event, slick) {
        $(this).find('.slick-next').attr('aria-controls', 'carousel-tab-2');

        slick.$slides.each(function (index) {
            $(this)
                .attr('id', 'carousel-tab-' + (index + 1))
                .attr('role', 'tabpanel')
                .attr('aria-label', 'Élément ' + (index + 1));
        });
    }).slick({
        slidesToShow: slidesToShow,
        arrows: withArrows,
        dots: withDots,
        dotsClass: dotsClass,
        speed: 200,
        infinite: false,
        swipeToSlide: true,
        variableWidth: variableWidth,
        prevArrow: '<button type="button" class="slick-prev"><i class="ri-arrow-left-line" aria-hidden="true"></i><span class="invisible-text">Écran précédent</span></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="ri-arrow-right-line" aria-hidden="true"></i><span class="invisible-text">Écran suivant</span></button>',
        customPaging: (slick, index) => '<button type="button"><span class="slick-dot-icon" aria-hidden="true"></span><span class="slick-sr-only">Aller à l\'écran ' + (index + 1) + '</span></button>',
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: Math.max(slidesToShow - 1, 1),
                    arrows: true
                }
            }, {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    arrows: true
                }
            }
        ],
    }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        let $t = $(this),
            slidesCount = slick.slideCount,
            firstSlide = 0;

        slick.$slides.each(function (index) {
            $(this)
                .attr('id', 'carousel-tab-' + (index + 1))
                .attr('role', 'tabpanel')
                .attr('aria-label', 'Élément ' + (index + 1));
        });

        if (nextSlide >= (slidesCount - slidesToShow)) {
            $t.find('.slick-next').attr('aria-label', 'Dernière publication');
        } else if (nextSlide <= firstSlide) {
            $t.find('.slick-prev').attr('aria-label', 'Première publication');
        } else {
            $t.find('.slick-prev').attr('aria-label', 'Publication précédente');
            $t.find('.slick-next').attr('aria-label', 'Publication suivante');
        }

        $t.find('.slick-slide').addClass($t.data('slide-class')).find('> div > .card').css('display', '');
    }).on('afterChange', function (event, slick, currentSlide) {
        $(this).attr('data-slides-label', (currentSlide + 1) + '/' + slick.slideCount);

        // If is last slide
        if (slick.slideCount === (currentSlide + 1)) {
            $('button[data-slick-goto-prev]:disabled').removeAttr('disabled');
            $('button[data-slick-goto-next]').attr('disabled', '');

            $('[data-slick-hide-on-last]').addClass('hidden');
            $('[data-slick-show-on-last]').removeClass('hidden');
        } else {
            $('button[data-slick-goto-next]:disabled').removeAttr('disabled');

            if (currentSlide === 0) {
                $('button[data-slick-goto-prev]').attr('disabled', '');
            } else {
                $('button[data-slick-goto-prev]:disabled').removeAttr('disabled');
            }

            $('[data-slick-hide-on-last]').removeClass('hidden');
            $('[data-slick-show-on-last]').addClass('hidden');
        }

        $(this).find('.slick-prev').attr('aria-controls', 'carousel-tab-' + currentSlide);
        $(this).find('.slick-next').attr('aria-controls', 'carousel-tab-' + (currentSlide + 2));

        $('button[data-slick-goto-prev]').attr('aria-controls', 'carousel-tab-' + currentSlide);
        $('button[data-slick-goto-next]').attr('aria-controls', 'carousel-tab-' + (currentSlide + 2));

        $('button[data-slick-goto]').removeAttr('aria-current');
        $('button[data-slick-goto="' + (currentSlide + 1) + '"]').attr('aria-current', 'page');
    });

    const slidesCount = $slider.find('.slick-slide').length;
    $slider.attr('data-slides-label', '1/' + slidesCount);

    $slider.find('.slick-slide').each(function (index) {
        $(this).prepend('<p class="invisible-text">Élément ' + (index + 1) + ' sur ' + slidesCount + '</p>');
    })

    $slider.find('.slick-slide').addClass($slider.data('slide-class')).find('> div > .card').css('display', '');
});

$('button[data-slick-goto-prev]').attr('role', 'tab').click(() => $('.selector-slick').slick('slickPrev'));
$('button[data-slick-goto-next]').attr('role', 'tab').click(() => $('.selector-slick').slick('slickNext'));
$('button[data-slick-goto]').attr('role', 'tab').click(event => $('.selector-slick').slick('slickGoTo', $(event.currentTarget).attr('data-slick-goto') - 1));